import { render, staticRenderFns } from "./tunai.vue?vue&type=template&id=11b37881"
import script from "./tunai.vue?vue&type=script&lang=js"
export * from "./tunai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports